import { setMessageSource } from '../../Store/features/messageSource/messageSourceSlice';
import { XIcon } from '@phosphor-icons/react';
import { Button } from '../Utility/Button';
import { RootState, useAppDispatch, useAppSelector } from '../../store';

function MessageSource() {
    const dispatch = useAppDispatch();
    const messageIdentifier = useAppSelector((state: RootState) => state.messageSource.messageIdentifier);
    const content = useAppSelector((state: RootState) => state.messageSource.content);
    const i18n = useAppSelector((state: RootState) => state.i18n.i18n);
    return (
        <>
            <div
                className={`hidden xl:block relative overflow-hidden transition-all duration-300 h-[var(--app-height)] bg-chatlist-background z-[5000] border-layout-borderColor ${
                    messageIdentifier !== '' ? 'w-[400px] border-l ' : 'w-0 border-0'
                }`}
            >
                {messageIdentifier !== '' && (
                    <div className="absolute w-[400px] h-full overflow-hidden">
                        <div className="h-[100px] border-b border-layout-borderColor flex items-center justify-between px-6">
                            <h4>
                                {i18n.translate({
                                    id: 'chatMessage.sources.headline',
                                    sourceName: 'Chat',
                                })}
                            </h4>
                            <Button
                                variant="secondaryBigRound"
                                onClick={() =>
                                    dispatch(
                                        setMessageSource({
                                            messageIdentifier: '',
                                            content: [
                                                {
                                                    title: '',
                                                    description: '',
                                                    url: '',
                                                },
                                            ],
                                        }),
                                    )
                                }
                            >
                                <XIcon size={24} />
                            </Button>
                        </div>
                        <div className="p-6 flex flex-col gap-2 overflow-y-auto h-[calc(var(--app-height)-100px)]">
                            {content.length > 0 &&
                                content.map((value: any, index: number) => (
                                    <a
                                        key={index}
                                        className="no-underline text-chatlist-textcolor hover:text-layout-textcolor py-1 px-2 hover:bg-chatlist-item-background-hover rounded-lg text-sm"
                                        target="_blank"
                                        rel="noreferrer noopener"
                                        href={value.url}
                                    >
                                        {value.domain && (
                                            <span className="line-clamp-1 flex items-center mb-2">
                                                {value.favicon && (
                                                    <img
                                                        src={value.favicon}
                                                        alt={value.domain}
                                                        className="w-4 h-4 rounded-full inline-block mr-2"
                                                    />
                                                )}
                                                {value.domain}
                                            </span>
                                        )}
                                        <strong className="line-clamp-2">{value.title}</strong>
                                        <span className="line-clamp-2">{value.description}</span>
                                    </a>
                                ))}
                        </div>
                    </div>
                )}
            </div>

            {messageIdentifier && (
                <div
                    className="block xl:hidden absolute top-0 left-0 h-[var(--app-height)] overflow-hidden w-full bg-black bg-opacity-50 z-[5000] transition-all duration-300"
                    onClick={() =>
                        dispatch(
                            setMessageSource({
                                messageIdentifier: '',
                                content: [
                                    {
                                        title: '',
                                        description: '',
                                        url: '',
                                    },
                                ],
                            }),
                        )
                    }
                >
                    <div className="absolute m-auto rounded-lg overflow-hidden left-0 right-0 top-0 bottom-0 w-[90%]  max-w-[400px] h-[calc(var(--app-height)-2rem)] bg-chatlist-background border-layout-borderColor">
                        <div className="h-[100px] border-b border-layout-borderColor flex items-center justify-between px-6 ">
                            <h4>
                                {i18n.translate({
                                    id: 'chatMessage.sources.headline',
                                    sourceName: 'Chat',
                                })}
                            </h4>
                            <Button
                                variant="secondaryBigRound"
                                onClick={() =>
                                    dispatch(
                                        setMessageSource({
                                            messageIdentifier: '',
                                            content: [
                                                {
                                                    title: '',
                                                    description: '',
                                                    url: '',
                                                },
                                            ],
                                        }),
                                    )
                                }
                            >
                                <XIcon size={24} />
                            </Button>
                        </div>
                        <div className="p-6 flex flex-col gap-2 overflow-y-auto h-[calc(var(--app-height)-2rem-100px)] ">
                            {content.length > 0 &&
                                content.map((value: any, index: number) => (
                                    <a
                                        key={index}
                                        className="no-underline text-chatlist-textcolor hover:text-layout-textcolor py-1 px-2 hover:bg-chatlist-item-background-hover rounded-lg text-sm"
                                        target="_blank"
                                        rel="noreferrer noopener"
                                        href={value.url}
                                    >
                                        <strong className="line-clamp-2">{value.title}</strong>
                                        <span className="line-clamp-2">{value.description}</span>
                                    </a>
                                ))}
                        </div>
                    </div>
                </div>
            )}
        </>
    );
}

export default MessageSource;
